import AddressRepository from './AddressRepository';

export * from './AddressRepository';

export default AddressRepository;
